import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: surfaces/SurfaceController.java — GET /api/v1/surfaces. Cut 1 of the 2026-09-27 player
// review ("Automatic, sellers exempt"): a multiplayer surface shows once it has content. The same
// answer for every viewer.
export type SurfacesDto = { stalls: boolean; exchange: boolean; gallery: boolean; guilds: boolean };

export const surfacesKey = ['surfaces'] as const;

export const getSurfaces = () => apiFetch<SurfacesDto>('/surfaces');

const NONE: SurfacesDto = { stalls: false, exchange: false, gallery: false, guilds: false };

/** Every field is `false` while loading (and on error): an empty surface stays hidden. */
export function useSurfaces(enabled = true): SurfacesDto {
  return useQuery({ queryKey: surfacesKey, queryFn: getSurfaces, enabled }).data ?? NONE;
}
